import React from 'react';
import {Typograpgy,Appbar} from '@material-ui/core';

import './UserBar.css';
import { Nav, NavItem } from 'react-bootstrap';
import { NavMenu } from '../Navbar/NavbarElements';
import {CgProfile} from 'react-icons/cg';


function UserBar(props) {
  

    return (
        <div>
           <Nav>
               <NavMenu>
                   <NavItem style={{color:'whitesmoke'}}>
                   {/* <CgProfile /> */}
                        {/* <span className='pseudo'>{props.elm.charAt(0)}</span> */}
                      {props.img?<img src={props.img} alt='profile' className='profilepic' />:<CgProfile className='Cgprofile' />}  
                       <h5>{props.elm}</h5>
                   </NavItem>
               </NavMenu>
           </Nav>
        </div>
    )
}

export default UserBar
